import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/* [CF 2026-08-17 #11.15] Client: "registered show English". Every string on this
 * screen was hardcoded, so the whole page stayed in English on the Arabic site.
 * Also switched `class` to `className` — React does not apply a raw `class`
 * attribute the way the rest of the app expects, and it logs a warning for each.
 *
 * Reached only by the redirect after a successful registration
 * (`window.location.href = '#/register-as'`), and it lives in the logged-in
 * route table, so it cannot be opened directly while signed out.
 */
export default function RegisterAs() {
	const { t } = useTranslation();

	return (
		<>
			<div className='login-reg-area'>
				<div className='container'>
					<div className='login-reg-wrap'>
						<h1 className='mb-5'>{t('Register')}</h1>
						<p className='text-center'>
							{t('You have been successfully Registered')}
						</p>
						<h5 className='text-center mb-5'>{t('Continue as')}</h5>

						<div className='row justify-content-center'>
							<div className='col-6 col-sm-6 col-md-4'>
								<div className='reg-as-wrap'>
									<Link to='/user-dashboard'>
										<div className='reg-as-wrap-a'>
											<img
												src='assets/images/icons/reg-as/user.svg'
												className='img-fluid'
												alt=''
											/>
										</div>
										<div className='reg-as-wrap-b'>{t('User')}</div>
									</Link>
								</div>
							</div>

							<div className='col-6 col-sm-6 col-md-4'>
								<div className='reg-as-wrap'>
									<Link to='/sp-dashboard'>
										<div className='reg-as-wrap-a'>
											<img
												src='assets/images/icons/reg-as/service-provider.svg'
												className='img-fluid'
												alt=''
											/>
										</div>
										<div className='reg-as-wrap-b'>{t('Service Provider')}</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
